function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import React from "react";
export default ({
  styles = {},
  ...props
}) => /*#__PURE__*/React.createElement("svg", _extends({
  width: "20",
  height: "20",
  xmlns: "http://www.w3.org/2000/svg"
}, props), /*#__PURE__*/React.createElement("g", {
  transform: "translate(0 1)",
  fill: "currentColor",
  fillRule: "evenodd"
}, /*#__PURE__*/React.createElement("rect", {
  y: "18",
  width: "19",
  height: "1",
  rx: ".5"
}), /*#__PURE__*/React.createElement("rect", {
  x: "3",
  y: "6",
  width: "5",
  height: "11",
  rx: "1"
}), /*#__PURE__*/React.createElement("rect", {
  x: "3",
  width: "5",
  height: "5",
  rx: "1"
}), /*#__PURE__*/React.createElement("rect", {
  x: "11",
  y: "13",
  width: "5",
  height: "4",
  rx: "1"
}), /*#__PURE__*/React.createElement("rect", {
  x: "11",
  y: "3",
  width: "5",
  height: "9",
  rx: "1"
})));